import { gql } from '@apollo/client'

const UPDATE_LOCATION_CUISINE_TYPE_AND_LOCATION_TYPE_SAME_AS_BRAND_MUTATION = gql`
  mutation updateLocationCuisineTypeAndLocationTypeSameAsBrandMutation(
    $id: ID!
    $areLocationCuisineTypeAndLocationTypeSameAsBrand: Boolean!
  ) {
    updateLocationCuisineTypeAndLocationTypeSameAsBrand(
      id: $id
      areLocationCuisineTypeAndLocationTypeSameAsBrand: $areLocationCuisineTypeAndLocationTypeSameAsBrand
    ) {
      id
      areLocationCuisineTypeAndLocationTypeSameAsBrand
    }
  }
`

export default UPDATE_LOCATION_CUISINE_TYPE_AND_LOCATION_TYPE_SAME_AS_BRAND_MUTATION
